import './Benefits.scss';
import { useEffect } from 'react';
import BenefitsAdditionalContent from '../../../components/BenefitsAdditionalContent/BenefitsAdditionalContent';
import BenefitsCoupons from '../../../components/BenefitsCoupons/BenefitsCoupons';
import BenefitsNewServicing from '../../../components/BenefitsNewServicing/BenefitsNewServicing';
import DiscoverHeader from '../../../components/DiscoverHeader/DiscoverHeader';
import FeaturedBenefits from '../../../components/FeaturedBenefits/FeaturedBenefits';
import { useTranslation } from 'react-i18next';
import { Box, Grid } from '@mui/material';

const Benefits = () => {
  const { t } = useTranslation();
  const json = t('ndc-program.benefits', { returnObjects: true });

  const discoverHeader = {
    breadcrumb: json['section.header'].breadcrumb,
    image: 'benefits.png',
    headerHtmlString: t('benefits_header')
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const couponRef: any[] = [];

  useEffect(() => {
    if (window.location.search) {
      const goto = window.location.search.replace('?', '');

      if (goto === 'coupon') {
        couponRef[0] &&
          couponRef[0].scrollIntoView({
            block: 'center'
          });
      }
    }
  }, [couponRef, t]);

  return (
    <>
      {json && (
        <main className="benefits-container">
          <DiscoverHeader {...discoverHeader} />
          <FeaturedBenefits
            data={
              t('benefits_featured_benefits', {
                returnObjects: true,
                defaultValue: []
              })[0]
            }
          />
          <hr className="divider" />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '60px'
            }}
          >
            <Grid
              container
              sx={{
                maxWidth: '1200px',
                width: '100%',
                marginX: '32px',

                '@media (max-width: 900px)': {
                  maxWidth: '704px'
                },
                '@media (max-width: 600px)': {
                  maxWidth: '344px',
                  rowGap:10
                }
              }}
            >
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  paddingRight: '10px',
                  '@media (max-width: 900px)': {
                    paddingRight: '0px'
                  }
                }}
              >
                <BenefitsNewServicing
                  data={
                    t('benefits_functions', {
                      returnObjects: true,
                      defaultValue: []
                    })[0]
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  paddingLeft: '10px',
                  '@media (max-width: 900px)': {
                    paddingLeft: '0px'
                  }
                }}
              >
                <BenefitsAdditionalContent
                  data={
                    t('benefits_additional_content', {
                      returnObjects: true,
                      defaultValue: []
                    })[0]
                  }
                />
              </Grid>
            </Grid>
          </Box>

          <div ref={(el) => couponRef.push(el)}>
            <BenefitsCoupons />
          </div>
        </main>
      )}
    </>
  );
};

export default Benefits;
